import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-success-page',
  templateUrl: './payment-success-page.component.html',
  styleUrl: './payment-success-page.component.scss'
})
export class PaymentSuccessPageComponent {}
